export var FwPacket;
(function (FwPacket) {
    function create(l3, token, congestionMark) {
        return { l3, token, congestionMark };
    }
    FwPacket.create = create;
    /** Determine whether this is a plain packet that can be sent on the wire. */
    function isEncodable({ reject, cancel }) {
        return !reject && !cancel;
    }
    FwPacket.isEncodable = isEncodable;
})(FwPacket || (FwPacket = {}));
/** Indicate an Interest has been rejected. */
export class RejectInterest {
    reject;
    l3;
    token;
    constructor(reject, l3, token) {
        this.reject = reject;
        this.l3 = l3;
        this.token = token;
    }
}
/** Request to cancel a pending Interest. */
export class CancelInterest {
    l3;
    token;
    constructor(l3, token) {
        this.l3 = l3;
        this.token = token;
    }
    cancel = true;
}
